import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ConnectButton from '../atoms/ConnectButton';
import RelationOffButton from '../atoms/RelationOffButton';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      gochiEventId: PropTypes.number,
      gochiEventName: PropTypes.string,
      startDate: PropTypes.string,
      menuEventLiked: PropTypes.number
    })
  ).isRequired,
  connectAction: PropTypes.func,
  disconnectAction: PropTypes.func,
  menuStatus: PropTypes.number
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({ events, connectAction, disconnectAction, order, orderBy, menuStatus }) => {
    const sortedResult = _.orderBy(events, orderBy, order);
    return (
      <TableBody>
        {sortedResult.map(gochiEvent => {
          const key = `${gochiEvent.gochiEventId}`;
          return (
            <TableRow key={key} hover>
              <TableCell>
                <ConnectButton
                  id={gochiEvent}
                  onClickAction={connectAction}
                  btnText="イベント紐づけ"
                  disabled={menuStatus}
                />
              </TableCell>
              <TableCell>
                <RelationOffButton
                  id={gochiEvent}
                  onClickAction={disconnectAction}
                  disabled={!gochiEvent.menuEventLiked}
                />
              </TableCell>
              <TableCell>{gochiEvent.gochiEventName}</TableCell>
              <TableCell>
                {gochiEvent.startDate &&
                  moment(gochiEvent.startDate).format('YYYY-MM-DD HH:mm:ss')}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
